import { render } from "./Sku.vue?vue&type=template&id=c9ab5182&scoped=true"
import script from "./Sku.vue?vue&type=script&lang=js"
export * from "./Sku.vue?vue&type=script&lang=js"

import "./Sku.vue?vue&type=style&index=0&id=c9ab5182&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ab5182"]])

export default __exports__